<div class="modal-help" [class.public-route]="isPublicRoute && isMobile">
  
  <div class="d-flex flex-column h-100"  style="overflow-y: auto; overflow-x: hidden;padding-left: 5px; padding-right: 5px;">
    <div class="d-flex flex-row justify-between align-item-center b-bottom main-padding"  >
      <div class="d-flex flex-column justify-center">
        <p class="mat-headline-5 color-text main-title" id="cookies.modal.title"> {{'cookies.modal.title' | translate}}</p>
      </div>
      @if(showClose ) {
        <div (click)="closeDialog()" style="width: 40px;height: 40px;"
          id="close-dilog"
          class="d-flex flex-row justify-center align-item-center cursor-pointer m-b-10">
          <fa-icon [icon]="['fal','times']" [fixedWidth]="false" class="font-16 icon-border"></fa-icon>
        </div>
      }
    </div>
 <div class="main-padding">

    <div class="w-100 m-t-15 p-t-5 m-b-15">
      <p class="mat-subtitle-1 color-text m-0" id="cookies.modal.what-are-cookies-title"
        [innerHTML]="'cookies.modal.what-are-cookies-title' | translate | sanitizeHtml"></p>
    </div>

    <p class="mat-body-2 color-text m-0" id="cookies.modal.what-are-cookies-description"
      [innerHTML]="'cookies.modal.what-are-cookies-description' | translate | sanitizeHtml"></p>

    <div class="w-100 m-t-30">
      <p class="mat-subtitle-1 color-text m-b-15" id="cookies.modal.type-cookies-title">{{'cookies.modal.type-cookies-title'
        | translate}}</p>
      <p class="mat-body-2 m-b-15" id="cookies.modal.type-cookies-subtitle">{{'cookies.modal.type-cookies-subtitle' |
        translate }}</p>
      <ol class="m-t-20">
        <li class="mat-body-2 color-text ">
          <p id="cookies.modal.type-cookies-description-1"
            [innerHTML]="'cookies.modal.type-cookies-description-1' | translate | sanitizeHtml"></p>
          <p id="cookies.modal.type-cookies-description-1-2"
            [innerHTML]="'cookies.modal.type-cookies-description-1-2' | translate | sanitizeHtml"></p>
          <ul style="padding-left: 20px;">
            <li id="cookies.modal.type-cookies-description-1-2-youtube"
              [innerHTML]="'cookies.modal.type-cookies-description-1-2-youtube' | translate | sanitizeHtml"> </li>
            <li id="cookies.modal.type-cookies-description-1-2-facebook"
              [innerHTML]="'cookies.modal.type-cookies-description-1-2-facebook' | translate | sanitizeHtml"> </li>
            <li id="cookies.modal.type-cookies-description-1-2-instagram"
              [innerHTML]="'cookies.modal.type-cookies-description-1-2-instagram' | translate | sanitizeHtml"> </li>
            <li id="cookies.modal.type-cookies-description-1-2-twitter"
              [innerHTML]="'cookies.modal.type-cookies-description-1-2-twitter' | translate | sanitizeHtml"> </li>

          </ul>

        </li>
        <li class="mat-body-2 color-text m-t-20 ">
          <p id="cookies.modal.type-cookies-description-2"
            [innerHTML]="'cookies.modal.type-cookies-description-2' | translate | sanitizeHtml">
          </p>
          <ul style="padding-left: 20px;">
            <li id="cookies.modal.type-cookies-description-2-1"
              [innerHTML]="'cookies.modal.type-cookies-description-2-1'  | translate | sanitizeHtml"></li>
            <li id="cookies.modal.type-cookies-description-2-2"
              [innerHTML]="'cookies.modal.type-cookies-description-2-2'  | translate | sanitizeHtml"></li>

          </ul>

        </li>
        <li class="mat-body-2 color-text m-t-20">
          <p id="cookies.modal.type-cookies-description-3"
            [innerHTML]="'cookies.modal.type-cookies-description-3' | translate | sanitizeHtml"></p>
          <ul style="padding-left: 20px;">
            <li id="cookies.modal.type-cookies-description-3-1"
              [innerHTML]="'cookies.modal.type-cookies-description-3-1' | translate | sanitizeHtml"> </li>
            <li id="cookies.modal.type-cookies-description-3-2"
              [innerHTML]="'cookies.modal.type-cookies-description-3-2' | translate | sanitizeHtml"> </li>

          </ul>

        </li>
        <li class="mat-body-2 color-text m-t-20 ">
          <p id="cookies.modal.type-cookies-description-4"
          [innerHTML]="'cookies.modal.type-cookies-description-4' | translate | sanitizeHtml"></p>
          <ul  style="padding-left: 20px;">
            <li id="cookies.modal.type-cookies-description-4-1"
            [innerHTML]="'cookies.modal.type-cookies-description-4-1' | translate | sanitizeHtml">

            </li>
            <li id="cookies.modal.type-cookies-description-4-2"
            [innerHTML]="'cookies.modal.type-cookies-description-4-2' | translate | sanitizeHtml">

            </li>

          </ul>
        </li>

      </ol>


    </div>
    <div class="w-100 m-t-30">
      <p class="mat-subtitle-1  color-text m-b-15" id="cookies.modal.transfer-cookies-title">{{'cookies.modal.transfer-cookies-title' | translate}}</p>
      <p class="mat-body-2 m-b-15" id="cookies.modal.transfer-cookies-description" [innerHTML]="'cookies.modal.transfer-cookies-description' | translate | sanitizeHtml"></p>
   </div>

   <div class="w-100 m-t-30">
    <p class="mat-subtitle-1  color-text m-b-15" id="cookies.modal.conservation-cookies-title">{{'cookies.modal.conservation-cookies-title' | translate}}</p>
    <p class="mat-body-2 m-b-15" id="cookies.modal.conservation-cookies-description" [innerHTML]="'cookies.modal.conservation-cookies-description' | translate | sanitizeHtml"></p>
   </div>

    <div class="w-100 m-t-30">
      <p class="mat-subtitle-1  color-text m-b-15" id="cookies.modal.tratment-cookies-title">{{'cookies.modal.tratment-cookies-title' | translate}}</p>
      <p class="mat-body-2 m-b-15" id="cookies.modal.tratment-cookies-description" [innerHTML]="'cookies.modal.tratment-cookies-description' | translate | sanitizeHtml"></p>
    </div>

    <div class="w-100 m-t-30">
      <p class="mat-subtitle-1  color-text m-b-15" id="cookies.modal.management-cookies-title">{{'cookies.modal.management-cookies-title' | translate}}</p>
      <p class="mat-body-2 m-b-15" id="cookies.modal.management-cookies-description" [innerHTML]="'cookies.modal.management-cookies-description' | translate | sanitizeHtml"></p>
    </div>
    <div class="w-100 m-t-30">
      <p class="mat-subtitle-1  color-text m-b-15" id="cookies.modal.third-parties-title">{{'cookies.modal.third-parties-title' | translate}}</p>
    </div>
    <div  class="desktop">
      <div class="header-table">
        <div class="header-type-cookies">
          <p class="p-l-5 p-r-5 p-t-10 p-b-10 m-b-0 header-text" id="cookies.modal.header-cookies-type">{{'cookies.modal.header-cookies-type' | translate}}</p>
        </div>
        <div class="header-cookies">
          <p class="p-l-5 p-r-5 p-t-10 p-b-10 m-b-0 header-text" id="cookies.modal.header-cookies"> {{'cookies.modal.header-cookies' | translate}}</p>
        </div>
        
        <div class="header-responsible">
          <p class="p-l-5 p-r-5 p-t-10 p-b-10 m-b-0 header-text" id="cookies.modal.header-responsible"> {{'cookies.modal.header-responsible' | translate}}</p>
        </div>

        <div class="header-info">
          <p class="p-l-5 p-r-5 p-t-10 p-b-10 m-b-0 header-text" id="cookies.modal.header-info"> {{'cookies.modal.header-info' | translate}}</p>
        </div>


      </div>
      <!-- GOOGLE ANALYTICS-->
        <div class="detail-table">

        <div class="header-type-cookies">
          <p class="m-b-0 detail-text"  id="cookies.modal.analysis-or-measurement">{{'cookies.modal.analysis-or-measurement' | translate }} </p>
        </div>

        <div class="header-cookies">
          <p class="m-b-0 detail-text"  id="cookies.modal.google-analytics">{{'cookies.modal.google-analytics' | translate }} </p>
        </div>

        <div class="header-responsible">
          <p class="m-b-0 detail-text"  id="cookies.modal.google-analytics-responsible">{{'cookies.modal.google-analytics-responsible' | translate }} </p>
        </div>

        <div class="header-info">
          <p class="m-b-0 detail-text"  id="cookies.modal.google-analytics-info" [innerHTML]="'cookies.modal.google-analytics-info' | translate | sanitizeHtml"> </p>
        </div>


      </div>

        <!-- CRAZYEGG -->
        <div class="detail-table">
        
          <div class="header-type-cookies">
            <p class="m-b-0 detail-text" id="cookies.modal.analysis-or-measurement">{{'cookies.modal.analysis-or-measurement' |
              translate }} </p>
          </div>
        
          <div class="header-cookies">
            <p class="m-b-0 detail-text" id="cookies.modal.crazyegg">{{'cookies.modal.crazyegg' | translate }} </p>
          </div>
        
          <div class="header-responsible">
            <p class="m-b-0 detail-text" id="cookies.modal.crazyegg-responsible">{{'cookies.modal.crazyegg-responsible' |
              translate }} </p>
          </div>
        
          <div class="header-info">
            <p class="m-b-0 detail-text" id="cookies.modal.crazyegg-info"
              [innerHTML]="'cookies.modal.crazyegg-info' | translate | sanitizeHtml"> </p>
          </div>
        
        </div>
        <!--FACEBOOK  -->
        <div class="detail-table">
        
          <div class="header-type-cookies">
            <p class="m-b-0 detail-text" id="cookies.modal.analysis-or-measurement">{{'cookies.modal.analysis-or-measurement' |
              translate }} </p>
          </div>
        
          <div class="header-cookies">
            <p class="m-b-0 detail-text" id="cookies.modal.facebook">{{'cookies.modal.facebook' | translate }} </p>
          </div>
        
          <div class="header-responsible">
            <p class="m-b-0 detail-text" id="cookies.modal.facebook-responsible">{{'cookies.modal.facebook-responsible' |
              translate }} </p>
          </div>
        
          <div class="header-info">
            <p class="m-b-0 detail-text" id="cookies.modal.facebook-info"
              [innerHTML]="'cookies.modal.facebook-info' | translate | sanitizeHtml"> </p>
          </div>
        
        </div>    

        <!-- GOOGLE BEACONS -->
        <div class="detail-table">
        
          <div class="header-type-cookies">
            <p class="m-b-0 detail-text" id="cookies.modal.analysis-or-measurement">{{'cookies.modal.analysis-or-measurement' |
              translate }} </p>
          </div>
        
          <div class="header-cookies">
            <p class="m-b-0 detail-text" id="cookies.modal.google-beacons">{{'cookies.modal.google-beacons' | translate }} </p>
          </div>
        
          <div class="header-responsible">
            <p class="m-b-0 detail-text" id="cookies.modal.google-beacons-responsible">{{'cookies.modal.google-beacons-responsible' |
              translate }} </p>
          </div>
        
          <div class="header-info">
            <p class="m-b-0 detail-text" id="cookies.modal.google-beacons-info"
              [innerHTML]="'cookies.modal.google-beacons-info' | translate | sanitizeHtml"> </p>
          </div>
        
        </div>  
        <!-- ADDTHIS -->
        <div class="detail-table">
        
          <div class="header-type-cookies">
            <p class="m-b-0 detail-text" id="cookies.modal.advertising-behavioral">{{'cookies.modal.advertising-behavioral' |
              translate }} </p>
          </div>
        
          <div class="header-cookies">
            <p class="m-b-0 detail-text" id="cookies.modal.addthis">{{'cookies.modal.addthis' | translate }} </p>
          </div>
        
          <div class="header-responsible">
            <p class="m-b-0 detail-text" id="cookies.modal.addthis-responsible">{{'cookies.modal.addthis-responsible' |
              translate }} </p>
          </div>
        
          <div class="header-info">
            <p class="m-b-0 detail-text" id="cookies.modal.addthis-info"
              [innerHTML]="'cookies.modal.addthis-info' | translate | sanitizeHtml"> </p>
          </div>
        
        </div>  
        <!-- DOUBLECLICK -->
        <div class="detail-table">
        
          <div class="header-type-cookies">
            <p class="m-b-0 detail-text" id="cookies.modal.advertising-behavioral">{{'cookies.modal.advertising-behavioral' |
              translate }} </p>
          </div>
        
          <div class="header-cookies">
            <p class="m-b-0 detail-text" id="cookies.modal.doubleclick">{{'cookies.modal.doubleclick' | translate }} </p>
          </div>
        
          <div class="header-responsible">
            <p class="m-b-0 detail-text" id="cookies.modal.doubleclick-responsible">{{'cookies.modal.doubleclick-responsible' |
              translate }} </p>
          </div>
        
          <div class="header-info">
            <p class="m-b-0 detail-text" id="cookies.modal.doubleclick-info"
              [innerHTML]="'cookies.modal.doubleclick-info' | translate | sanitizeHtml"> </p>
          </div>
        
        </div> 
        <!-- FACEBOOK-CUSTOM -->
        <div class="detail-table">
          <div class="header-type-cookies">
            <p class="m-b-0 detail-text" id="cookies.modal.advertising-behavioral">{{'cookies.modal.advertising-behavioral' |
              translate }} </p>
          </div>
        
          <div class="header-cookies">
            <p class="m-b-0 detail-text" id="cookies.modal.facebook-custom">{{'cookies.modal.facebook-custom' | translate }} </p>
          </div>
        
          <div class="header-responsible">
            <p class="m-b-0 detail-text" id="cookies.modal.facebook-custom-responsible">{{'cookies.modal.facebook-custom-responsible' |
              translate }} </p>
          </div>
        
          <div class="header-info">
            <p class="m-b-0 detail-text" id="cookies.modal.facebook-custom-info"
              [innerHTML]="'cookies.modal.facebook-custom-info' | translate | sanitizeHtml"> </p>
          </div>
        
        </div>
        <!-- ADWORDS -->
        <div class="detail-table m-b-30">
          <div class="header-type-cookies">
            <p class="m-b-0 detail-text" id="cookies.modal.advertising-behavioral">{{'cookies.modal.advertising-behavioral' |
              translate }} </p>
          </div>
        
          <div class="header-cookies">
            <p class="m-b-0 detail-text" id="cookies.modal.adwords">{{'cookies.modal.adwords' | translate }} </p>
          </div>
        
          <div class="header-responsible">
            <p class="m-b-0 detail-text" id="cookies.modal.adwords-responsible">{{'cookies.modal.adwords-responsible' |
              translate }} </p>
          </div>
        
          <div class="header-info">
            <p class="m-b-0 detail-text" id="cookies.modal.adwords-info"
              [innerHTML]="'cookies.modal.adwords-info' | translate | sanitizeHtml"> </p>
          </div>
        
        </div>
    </div>
    <div  class="mobile">
      <!-- <div class="header-table">
        <div class="header-type-cookies">
          <p class="p-l-5 p-r-5 p-t-10 p-b-10 m-b-0 header-text" id="cookies.modal.header-cookies-type">{{'cookies.modal.header-cookies-type' | translate}}</p>
        </div>
        <div class="header-cookies">
          <p class="p-l-5 p-r-5 p-t-10 p-b-10 m-b-0 header-text" id="cookies.modal.header-cookies"> {{'cookies.modal.header-cookies' | translate}}</p>
        </div>
        
        <div class="header-responsible">
          <p class="p-l-5 p-r-5 p-t-10 p-b-10 m-b-0 header-text" id="cookies.modal.header-responsible"> {{'cookies.modal.header-responsible' | translate}}</p>
        </div>

        <div class="header-info">
          <p class="p-l-5 p-r-5 p-t-10 p-b-10 m-b-0 header-text" id="cookies.modal.header-info"> {{'cookies.modal.header-info' | translate}}</p>
        </div>


      </div> -->
      <div>
        <div class="detail-table">
          <div class="d-flex flex-column" style="margin: 10px 10px">
            <p><b>{{'cookies.modal.google-analytics' | translate }}</b></p>
            <p> <b>{{'cookies.modal.header-cookies-type' | translate}}:</b> {{'cookies.modal.analysis-or-measurement' |
              translate }} </p>
            <p><b>{{'cookies.modal.header-responsible' | translate}}:</b> {{'cookies.modal.google-analytics-responsible' |
              translate }} </p>
            <p><b>{{'cookies.modal.header-info' | translate}}:</b> <span
                [innerHTML]="'cookies.modal.google-analytics-info' | translate | sanitizeHtml"></span> </p>
          </div>
        </div>

        <div class="detail-table">
          <div class="d-flex flex-column" style="margin: 10px 10px">
            <p><b>{{'cookies.modal.crazyegg' | translate }}</b></p>
            <p> <b>{{'cookies.modal.header-cookies-type' | translate}}:</b> {{'cookies.modal.analysis-or-measurement' |
              translate }} </p>
            <p><b>{{'cookies.modal.header-responsible' | translate}}:</b> {{'cookies.modal.crazyegg-responsible' |
              translate }} </p>
            <p><b>{{'cookies.modal.header-info' | translate}}:</b> <span
                [innerHTML]="'cookies.modal.crazyegg-info' | translate | sanitizeHtml"></span> </p>
          </div>
        </div>

        <div class="detail-table">
          <div class="d-flex flex-column" style="margin: 10px 10px">
            <p><b>{{'cookies.modal.facebook' | translate }}</b></p>
            <p> <b>{{'cookies.modal.header-cookies-type' | translate}}:</b> {{'cookies.modal.analysis-or-measurement' |
              translate }} </p>
            <p><b>{{'cookies.modal.header-responsible' | translate}}:</b> {{'cookies.modal.facebook-responsible' |
              translate }} </p>
            <p><b>{{'cookies.modal.header-info' | translate}}:</b> <span
                [innerHTML]="'cookies.modal.facebook-info' | translate | sanitizeHtml"></span> </p>
          </div>
        </div>

        <div class="detail-table">
          <div class="d-flex flex-column" style="margin: 10px 10px">
            <p><b>{{'cookies.modal.google-beacons' | translate }}</b></p>
            <p> <b>{{'cookies.modal.header-cookies-type' | translate}}:</b> {{'cookies.modal.analysis-or-measurement' |
              translate }} </p>
            <p><b>{{'cookies.modal.header-responsible' | translate}}:</b> {{'cookies.modal.google-beacons-responsible' |
              translate }} </p>
            <p><b>{{'cookies.modal.header-info' | translate}}:</b> <span
                [innerHTML]="'cookies.modal.google-beacons-info' | translate | sanitizeHtml"></span> </p>
          </div>
        </div>

        <div class="detail-table">
          <div class="d-flex flex-column" style="margin: 10px 10px">
            <p><b>{{'cookies.modal.addthis' | translate }}</b></p>
            <p> <b>{{'cookies.modal.header-cookies-type' | translate}}:</b> {{'cookies.modal.advertising-behavioral' |
              translate }} </p>
            <p><b>{{'cookies.modal.header-responsible' | translate}}:</b> {{'cookies.modal.addthis-responsible' |
              translate }} </p>
            <p><b>{{'cookies.modal.header-info' | translate}}:</b> <span
                [innerHTML]="'cookies.modal.addthis-info' | translate | sanitizeHtml"></span> </p>
          </div>
        </div>
        <div class="detail-table">
          <div class="d-flex flex-column" style="margin: 10px 10px">
            <p><b>{{'cookies.modal.doubleclick' | translate }}</b></p>
            <p> <b>{{'cookies.modal.header-cookies-type' | translate}}:</b> {{'cookies.modal.advertising-behavioral' |
              translate }} </p>
            <p><b>{{'cookies.modal.header-responsible' | translate}}:</b> {{'cookies.modal.doubleclick-responsible' |
              translate }} </p>
            <p><b>{{'cookies.modal.header-info' | translate}}:</b> <span
                [innerHTML]="'cookies.modal.doubleclick-info' | translate | sanitizeHtml"></span> </p>
          </div>
        </div>

        <div class="detail-table">
          <div class="d-flex flex-column" style="margin: 10px 10px">
            <p><b>{{'cookies.modal.facebook-custom' | translate }}</b></p>
            <p> <b>{{'cookies.modal.header-cookies-type' | translate}}:</b> {{'cookies.modal.advertising-behavioral' |
              translate }} </p>
            <p><b>{{'cookies.modal.header-responsible' | translate}}:</b> {{'cookies.modal.facebook-custom-responsible' |
              translate }} </p>
            <p><b>{{'cookies.modal.header-info' | translate}}:</b> <span
                [innerHTML]="'cookies.modal.facebook-custom-info' | translate | sanitizeHtml"></span> </p>
          </div>
        </div>
      
        <div class="detail-table">
          <div class="d-flex flex-column" style="margin: 10px 10px">
            <p><b>{{'cookies.modal.adwords' | translate }}</b></p>
            <p> <b>{{'cookies.modal.header-cookies-type' | translate}}:</b> {{'cookies.modal.advertising-behavioral' |
              translate }} </p>
            <p><b>{{'cookies.modal.header-responsible' | translate}}:</b> {{'cookies.modal.adwords-responsible' |
              translate }} </p>
            <p><b>{{'cookies.modal.header-info' | translate}}:</b> <span
                [innerHTML]="'cookies.modal.adwords-info' | translate | sanitizeHtml"></span> </p>
          </div>
        </div>
        
      </div>





    </div>
  </div>
